import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card shadow-sm mb-2 bg-white rounded txtLeft" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Find a specific employee by First and Last Name, Login, or EIN")
], -1)
const _hoisted_3 = {
  class: "card-body position-relative",
  style: {"background-color":"rgba(0, 0, 0, 0.03)"}
}
const _hoisted_4 = { id: "search-form" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "firstName" }, "FIRST NAME", -1)
const _hoisted_9 = ["min"]
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "lastName" }, "LAST NAME", -1)
const _hoisted_13 = ["min"]
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "login" }, "LOGIN", -1)
const _hoisted_17 = ["min"]
const _hoisted_18 = { class: "col" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "ein" }, "EIN", -1)
const _hoisted_21 = ["min"]
const _hoisted_22 = { class: "col text-end" }
const _hoisted_23 = {
  id: "search-content-loading",
  class: "text-center mt-3"
}
const _hoisted_24 = { class: "fa-2x" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Searching...")
], -1)
const _hoisted_26 = {
  key: 0,
  id: "search-content"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", {
  style: {"padding-bottom":"15px"},
  class: "txtLeft"
}, "Possible matches identified.", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", {
  style: {"padding-bottom":"15px"},
  class: "txtLeft"
}, "Select an employee in the grid below to create an assignment for them in your department.", -1)
const _hoisted_29 = { id: "grdSearch" }
const _hoisted_30 = {
  key: 1,
  id: "search-message",
  class: "text-center mt-3"
}
const _hoisted_31 = { id: "search-message-text" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { id: "care-assignment-container-staffsearch" }, null, -1)
const _hoisted_33 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_neu_button = _resolveComponent("neu-button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_table_heading = _resolveComponent("neu-table-heading")!
  const _component_neu_table_row = _resolveComponent("neu-table-row")!
  const _component_neu_label = _resolveComponent("neu-label")!
  const _component_neu_table_body = _resolveComponent("neu-table-body")!
  const _component_neu_table = _resolveComponent("neu-table")!
  const _component_neu_card = _resolveComponent("neu-card")!
  const _component_ToasterPopup = _resolveComponent("ToasterPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "neu-input",
                  id: "firstName",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstName) = $event)),
                  min: _ctx.minTxtLength,
                  onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.EnableSearchButton && _ctx.EnableSearchButton(...args))),
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.EnableSearchButton && _ctx.EnableSearchButton(...args))),
                  placeholder: "Enter",
                  style: {"padding-left":"5px !important"}
                }, null, 40, _hoisted_9), [
                  [_vModelText, _ctx.firstName]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "neu-input",
                  id: "lastName",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.lastName) = $event)),
                  min: _ctx.minTxtLength,
                  onKeyup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.EnableSearchButton && _ctx.EnableSearchButton(...args))),
                  onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.EnableSearchButton && _ctx.EnableSearchButton(...args))),
                  placeholder: "Enter",
                  style: {"padding-left":"5px !important"}
                }, null, 40, _hoisted_13), [
                  [_vModelText, _ctx.lastName]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "neu-input",
                  id: "login",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.login) = $event)),
                  min: _ctx.minTxtLength,
                  onKeyup: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.EnableSearchButton && _ctx.EnableSearchButton(...args))),
                  onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.EnableSearchButton && _ctx.EnableSearchButton(...args))),
                  placeholder: "Enter",
                  style: {"padding-left":"5px !important"}
                }, null, 40, _hoisted_17), [
                  [_vModelText, _ctx.login]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "neu-input",
                  id: "ein",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.ein) = $event)),
                  min: _ctx.minEinTxtLength,
                  onKeyup: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.EnableSearchButton && _ctx.EnableSearchButton(...args))),
                  onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.EnableSearchButton && _ctx.EnableSearchButton(...args))),
                  placeholder: "Enter",
                  style: {"padding-left":"5px !important"}
                }, null, 40, _hoisted_21), [
                  [_vModelText, _ctx.ein]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_neu_button, {
                type: "button",
                fill: "raised",
                style: {"position":"relative","top":"20px","min-width":"50%","float":"right !important"},
                disabled: _ctx.isDisableSearchBtn,
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isDisableSearchBtn ? null : _ctx.searchFormOnSubmit())),
                class: "col-md-3 padding0"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" SEARCH ")
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ])
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createVNode(_component_font_awesome_icon, {
          spin: true,
          icon: ['fas', 'circle-notch'],
          size: "lg"
        })
      ]),
      _hoisted_25
    ], 512), [
      [_vShow, _ctx.isShowLoader]
    ]),
    (_ctx.isShowStaffingContent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _hoisted_27,
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            (_ctx.staffSearchResult != null && _ctx.staffSearchResult.length > 0)
              ? (_openBlock(), _createBlock(_component_neu_card, {
                  key: 0,
                  color: "plain-0",
                  class: "p-0 m-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_neu_table, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_neu_table_row, {
                          columns: _ctx.columnHeaders,
                          header: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeaders), (column) => {
                              return (_openBlock(), _createBlock(_component_neu_table_heading, {
                                key: column,
                                icon: _ctx.columnIcons[column],
                                slot: column,
                                style: {"padding-top":"25px !important"},
                                onVNeuChange: ($event: any) => (_ctx.sortData($event,column))
                              }, {
                                default: _withCtx(() => [
                                  ((column != 'RN Experience' || (column == 'RN Experience' && _ctx.isRNExperienceFeatureEnabled)))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(column), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["icon", "slot", "onVNeuChange"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["columns"]),
                        _createVNode(_component_neu_table_body, { align: "left" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.staffSearchResult, (dataItem) => {
                              return (_openBlock(), _createBlock(_component_neu_table_row, {
                                columns: _ctx.columnHeaders,
                                slot: _ctx.column,
                                key: dataItem,
                                class: _normalizeClass([dataItem.Charge ? 'chargeAssignment': '']),
                                onClick: ($event: any) => (_ctx.onRowSelect(dataItem))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_neu_label, {
                                    slot: "First Name",
                                    title: dataItem.firstName
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.firstName), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["title"]),
                                  _createVNode(_component_neu_label, {
                                    slot: "Last Name",
                                    title: dataItem.lastName
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.lastName), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["title"]),
                                  _createVNode(_component_neu_label, {
                                    slot: "Facility",
                                    title: dataItem.facilityName
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.facilityName), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["title"]),
                                  _createVNode(_component_neu_label, {
                                    slot: "Department",
                                    title: dataItem.departmentDescription
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.departmentDescription), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["title"]),
                                  _createVNode(_component_neu_label, {
                                    slot: "Skills",
                                    title: dataItem.skills,
                                    class: _normalizeClass([dataItem.isOvertime ? 'gridOverTime': ''])
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.skills), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["title", "class"]),
                                  _createVNode(_component_neu_label, { slot: "Type" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.employeeType), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "FTE" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.fte), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "Hours" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.hours), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (dataItem.rnExperienceFeatureEnabled)
                                    ? (_openBlock(), _createBlock(_component_neu_label, {
                                        key: 0,
                                        slot: "RN Experience",
                                        class: _normalizeClass([dataItem.rnExperience == '< 1 Year' ? 'rn-experience': ''])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(dataItem.rnExperience), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_neu_label, { slot: "Hire Date" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridDateFormat(dataItem.hireDate)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "Seniority Date" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridDateFormat(dataItem.seniorityDate)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "End Date" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridDateFormat(dataItem.endDate)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "Last Cancelled" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridDateFormat(dataItem.lastCancelled)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, { slot: "Last Floated" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.setGridDateFormat(dataItem.lastFloated)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_neu_label, {
                                    slot: "Login",
                                    title: dataItem.threeFourId
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.threeFourId), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["title"]),
                                  _createVNode(_component_neu_label, {
                                    slot: "EIN",
                                    title: dataItem.ein
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(dataItem.ein), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["title"])
                                ]),
                                _: 2
                              }, 1032, ["columns", "slot", "class", "onClick"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowStaffingMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.staffingMessage), 1)
        ]))
      : _createCommentVNode("", true),
    _hoisted_32,
    (_ctx.isToasterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createVNode(_component_ToasterPopup, {
            onCloseModal: _ctx.closeToasterPopup,
            msgValue: _ctx.msgValue,
            classFlag: _ctx.classFlag
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}